import { render, staticRenderFns } from "./DashboardButton.vue?vue&type=template&id=28e36a74&scoped=true"
import script from "./DashboardButton.vue?vue&type=script&lang=js"
export * from "./DashboardButton.vue?vue&type=script&lang=js"
import style0 from "./DashboardButton.vue?vue&type=style&index=0&id=28e36a74&lang=scss&scoped=true"
import style1 from "./DashboardButton.vue?vue&type=style&index=1&id=28e36a74&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e36a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e36a74')) {
      api.createRecord('28e36a74', component.options)
    } else {
      api.reload('28e36a74', component.options)
    }
    module.hot.accept("./DashboardButton.vue?vue&type=template&id=28e36a74&scoped=true", function () {
      api.rerender('28e36a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home/DashboardButton.vue"
export default component.exports